import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './i18n'
import { useIdiomasStore } from './store/idiomas'
import { setI18nLanguage } from './i18n'
import config from '../config'

import { createPinia } from 'pinia'

// Library Components
import VueSweetalert2 from 'vue-sweetalert2'
import VueApexCharts from 'vue3-apexcharts'
import BootstrapVue3 from 'bootstrap-vue-3'
import CounterUp from 'vue3-autocounter'
import 'aos/dist/aos.css'

//library PrimeVue
import PrimeVue from 'primevue/config'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Avatar from 'primevue/avatar'
import Badge from 'primevue/badge'
import BadgeDirective from 'primevue/badgedirective'
import BlockUI from 'primevue/blockui'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import Carousel from 'primevue/carousel'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import DialogService from 'primevue/dialogservice'
import Divider from 'primevue/divider'
import Dropdown from 'primevue/dropdown'
import DynamicDialog from 'primevue/dynamicdialog'
import ConfirmDialog from 'primevue/confirmdialog'
import ConfirmationService from 'primevue/confirmationservice'
import Fieldset from 'primevue/fieldset'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import InputNumber from 'primevue/inputnumber'
import InputSwitch from 'primevue/inputswitch'
import InputText from 'primevue/inputtext'
import MultiSelect from 'primevue/multiselect'
import Panel from 'primevue/panel'
import Password from 'primevue/password'
import ProgressSpinner from 'primevue/progressspinner'
import ScrollTop from 'primevue/scrolltop'
import Sidebar from 'primevue/sidebar'
import SpeedDial from 'primevue/speeddial'
import TabPanel from 'primevue/tabpanel'
import TabView from 'primevue/tabview'
import Tag from 'primevue/tag'
import Textarea from 'primevue/textarea'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import Toolbar from 'primevue/toolbar'
import Tooltip from 'primevue/tooltip'
import Tree from 'primevue/tree'
import TriStateCheckbox from 'primevue/tristatecheckbox'

import 'primevue/resources/themes/bootstrap4-light-blue/theme.css'
import 'primeicons/primeicons.css'

// Custom Components & Directives
import globalComponent from './plugins/global-components'
import globalDirective from './plugins/global-directive'
import globalMixin from './plugins/global-mixin'

// Plugin global para i18n
const i18nPlugin = {
  install(app) {
    // Obtener la instancia de i18n directamente del módulo importado
    app.config.globalProperties.$t = i18n.global.t
    app.provide('$t', i18n.global.t)
  }
}

//iconos bootstrap
import 'bootstrap-icons/font/bootstrap-icons.css'

require('waypoints/lib/noframework.waypoints.min')
//CREACIÓN DE LA APP
const app = createApp(App)

// Library Pinia - MOVER ANTES para que esté disponible
const pinia = createPinia()
app.use(pinia)

//uso de vue-x & vue-router
app.use(store).use(router).use(i18n)

// Instalar el plugin i18n DESPUÉS de que i18n esté disponible
app.use(i18nPlugin)

//PRIMEVUE and components
app.use(PrimeVue, {
  ripple: true,
  inputStyle: 'outlined'
})
app.use(DialogService)
app.use(ToastService)
app.use(ConfirmationService)

app.component('AccordionControl', Accordion)
app.component('AccordionTab', AccordionTab)
app.component('AvatarControl', Avatar)
app.component('BadgeControl', Badge)
app.component('ConfirmDialog', ConfirmDialog)
app.component('BlockUI', BlockUI)
app.component('ButtonControl', Button)
app.component('CalendarControl', Calendar)
app.component('CarouselControl', Carousel)
app.component('CheckboxControl', Checkbox)
app.component('ColumnTable', Column)
app.component('DataTablePrime', DataTable)
app.component('DialogControl', Dialog)
app.component('DividerControl', Divider)
app.component('DropDown', Dropdown)
app.component('DynamicDialog', DynamicDialog)
app.component('FieldSet', Fieldset)
app.component('IconField', IconField)
app.component('InputIcon', InputIcon)
app.component('InputNumber', InputNumber)
app.component('InputSwitch', InputSwitch)
app.component('InputText', InputText)
app.component('MultiSelect', MultiSelect)
app.component('PanelControl', Panel)
app.component('PassWord', Password)
app.component('ProgressSpinner', ProgressSpinner)
app.component('ScrollTop', ScrollTop)
app.component('SideBar', Sidebar)
app.component('SpeedDial', SpeedDial)
app.component('TabPanel', TabPanel)
app.component('TabView', TabView)
app.component('TagControl', Tag)
app.component('TextArea', Textarea)
app.component('ToastControl', Toast)
app.component('ToolbarControl', Toolbar)
app.component('TreeView', Tree)
app.component('TriStateCheckbox', TriStateCheckbox)

app.directive('BadgeDirective', BadgeDirective)
app.directive('tooltip', Tooltip)

// Library Components
app.use(VueSweetalert2)
app.use(VueApexCharts)
app.use(BootstrapVue3)
app.component('counter-up', CounterUp)

// Custom Components & Directives
app.use(globalComponent)
app.use(globalDirective)
app.mixin(globalMixin)

// Función para inicializar el idioma
async function initializeLanguage() {
  const isLoggedIn = localStorage.getItem('login') === 'true'
  const token = localStorage.getItem('accesToken')

  const idiomasStore = useIdiomasStore()
  await idiomasStore.initialize()

  if (isLoggedIn && token) {
    // Usuario logueado - obtener su idioma configurado desde la BD
    try {
      const response = await fetch(config.apiBaseUrl + '/users/me', {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const userData = await response.json()
        if (userData.idioma && userData.idioma.codigo_iso) {
          // Usuario tiene idioma configurado en BD
          await idiomasStore.setCurrentLanguage(userData.idioma.codigo_iso)
          setI18nLanguage(userData.idioma.codigo_iso)
        } else {
          // Usuario sin idioma en BD - usar idioma del navegador y guardarlo en BD
          const browserLang = navigator.language.split('-')[0]
          const supportedLocales = ['en', 'es', 'fr', 'de', 'it', 'pt']
          const finalLang = supportedLocales.includes(browserLang) ? browserLang : 'en'

          await idiomasStore.setCurrentLanguage(finalLang)
          setI18nLanguage(finalLang)

          // Guardar idioma del navegador en BD para este usuario
          const idiomaEncontrado = idiomasStore.idiomas.find((i) => i.codigo_iso === finalLang)
          if (idiomaEncontrado) {
            await idiomasStore.cambiarIdiomaUsuarioBD(idiomaEncontrado.id)
          }
        }
      } else {
        // Error al obtener usuario, usar idioma del navegador
        const browserLang = navigator.language.split('-')[0]
        const supportedLocales = ['en', 'es', 'fr', 'de', 'it', 'pt']
        const finalLang = supportedLocales.includes(browserLang) ? browserLang : 'en'
        await idiomasStore.setCurrentLanguage(finalLang)
        setI18nLanguage(finalLang)
      }
    } catch (error) {
      console.warn('Error al obtener idioma del usuario:', error)
      // Fallback al idioma del navegador
      const browserLang = navigator.language.split('-')[0]
      const supportedLocales = ['en', 'es', 'fr', 'de', 'it', 'pt']
      const finalLang = supportedLocales.includes(browserLang) ? browserLang : 'en'
      await idiomasStore.setCurrentLanguage(finalLang)
      setI18nLanguage(finalLang)
    }
  } else {
    // Usuario no logueado - usar idioma del navegador (sin guardar en BD)
    const browserLang = navigator.language.split('-')[0]
    const supportedLocales = ['en', 'es', 'fr', 'de', 'it', 'pt']
    const finalLang = supportedLocales.includes(browserLang) ? browserLang : 'en'
    await idiomasStore.setCurrentLanguage(finalLang)
    setI18nLanguage(finalLang)
  }
}

// Inicializar idioma antes de montar la aplicación
initializeLanguage()
  .then(() => {
    app.mount('#app')
  })
  .catch((error) => {
    console.error('Error inicializando idioma:', error)
    // En caso de error, montar la aplicación de todos modos
    app.mount('#app')
  })

export default app
